import {
  IconAppCenter,
  IconClock,
  IconShoppingBag,
  IconUnlock,
  IconUserAdd,
  IconUserSetting,
} from '@douyinfe/semi-icons';
import React from 'react';
export interface MenuItem {
  itemKey: string;
  text: string | React.ReactNode;
  textId?: string;
  icon?: React.ReactNode;
  path?: string;
  items?: MenuItem[];
  link?: string;
  component?: React.ComponentType<any>;
}

// 静态菜单：仅保留"我的主页"。其它业务菜单走后端 /admin/menus 权限配置。
export const menuList: MenuItem[] = [
  {
    itemKey: 'dashboard',
    text: 'web.menu.dashboard',
    icon: <IconAppCenter />,
    path: '/dashboard',
  },
];

// 普通用户的角色菜单：完全走后端权限，前端不硬编码
export const userList: MenuItem[] = [];

// 管理员专属菜单：仅 admin 账号可见，不走后端权限
export const adminList: MenuItem[] = [
  {
    itemKey: 'web.menu.asn',
    text: 'web.menu.asn',
    icon: <IconClock />,
    path: '/asn',
  },
  {
    itemKey: 'web.menu.store-authorization',
    text: 'web.menu.store-authorization',
    icon: <IconShoppingBag />,
    path: '/store-authorization',
  },
  {
    itemKey: 'web.menu.buyer.list',
    text: 'web.menu.buyer.list',
    icon: <IconUserAdd />,
    path: '/admin/buyer/list',
  },
  {
    itemKey: 'web.menu.account',
    text: 'web.menu.account',
    icon: <IconUserSetting />,
    path: '/admin/account',
  },
  {
    itemKey: 'web.menu.menus',
    text: 'web.menu.menus',
    icon: <IconUnlock />,
    path: '/admin/menus',
  },
];
